import { auth, db } from "../Services/firebase-config";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { setDoc, doc } from "firebase/firestore";
import { uiActions } from "../Store/ui-slice";
import { useDispatch } from "react-redux";
import { useState } from "react";

export const useLog = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const signIn = async (email, pass) => {
    try {
      setError("");
      setIsLoading(true);
      const loggedUser = await signInWithEmailAndPassword(auth, email, pass);
      dispatch(
        uiActions.changeUserParamName({
          userParamName: loggedUser.user.displayName,
        })
      );
      dispatch(uiActions.changeUserDBId({ userDBId: loggedUser.user.uid }));
      setIsLoading(false);
      return loggedUser.user.displayName;
    } catch (err) {
      setIsLoading(false);
      setError("User Was Not Found!");
      dispatch(
        uiActions.changeUserParamName({
          userParamName: "",
        })
      );
      dispatch(uiActions.changeUserDBId({ userDBId: "" }));
    }
  };

  const signUp = async (email, pass, userName, passwordCheck) => {
    try {
      setIsLoading(true);
      if (passwordCheck === pass) {
        setError("")
        const createdUser = await createUserWithEmailAndPassword(
          auth,
          email,
          pass
        );
        dispatch(uiActions.changeUserParamName({ userParamName: userName }));
        dispatch(uiActions.changeUserDBId({ userDBId: createdUser.user.uid }));
        updateProfile(createdUser.user, { displayName: userName });
        await setDoc(doc(db, "users", createdUser.user.uid), {
          name: userName,
          email: email,
          id: createdUser.user.uid,
        });
        createdUser !== null && setIsLoading(false);
        return userName;
      } else {
        setError("Passwords Do Not Match");
        setIsLoading(false);
        dispatch(
          uiActions.changeUserParamName({
            userParamName: "",
          })
        );
        dispatch(uiActions.changeUserDBId({ userDBId: "" }));
      }
    } catch (err) {
      setIsLoading(false);
      setError("Something Went wrong while creating your user");
      dispatch(
        uiActions.changeUserParamName({
          userParamName: "",
        })
      );
      dispatch(uiActions.changeUserDBId({ userDBId: "" }));
    }
  };

  return [signUp, signIn, isLoading, error];
};
